import React from "react";
import styles from "./style.module.scss";
import PricingCard from "./components/shared/PricingCard";
import RateItem from "./components/shared/RateItem";
import { RegularCardIcons, AmexCardIcon } from "./constants/icons";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import formatPercentage from "./utils/format-percentage";
import formatCurrency from "./utils/format-currency";

const FlatRate = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  return (
    <div className={styles.flatRate}>
      <div className={styles.rateCards}>
        {/* Regular Cards Rate */}
        <PricingCard title="Rate Fees" icons={<RegularCardIcons />}>
          <div className={styles.ratesList}>
            <RateItem
              label="Flat Rate"
              value={formatPercentage(
                getPricingDataById(2, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Txn Rate"
              value={formatCurrency(
                getPricingDataById(2, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>

        {/* AMEX Rate */}
        <PricingCard title="Rate Fees AMEX" icons={<AmexCardIcon />}>
          <div className={styles.ratesList}>
            <RateItem
              label="Flat Rate"
              value={formatPercentage(
                getPricingDataById(35, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Txn Rate"
              value={formatCurrency(
                getPricingDataById(35, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>
      </div>
    </div>
  );
};

export default FlatRate;
